import React, { useEffect, useMemo, useState } from 'react';
import { getFileUrl } from '../utils/fileUtils';
import { buildUploadImageCandidates } from '../utils/cleroFotos';
import './NoticiaImage.css';

const NoticiaImage = ({ src, alt, className = '' }) => {
  const candidates = useMemo(() => {
    if (!src) return [];
    if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('/images/')) {
      const u = getFileUrl(src) || src;
      return u ? [u] : [];
    }
    const built = buildUploadImageCandidates(src);
    return built.length > 0 ? built : [getFileUrl(src)].filter(Boolean);
  }, [src]);

  const [attempt, setAttempt] = useState(0);
  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    setAttempt(0);
    setImageLoading(true);
  }, [src]);

  if (!src || candidates.length === 0) {
    return (
      <div className={`noticia-image-placeholder ${className}`}>
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <rect width="200" height="200" fill="#e9ecef" />
          <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fill="#6c757d" fontSize="14">
            Sin imagen
          </text>
        </svg>
      </div>
    );
  }

  if (attempt >= candidates.length) {
    return (
      <div className={`noticia-image-placeholder ${className}`}>
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <rect width="200" height="200" fill="#e9ecef" />
          <circle cx="100" cy="80" r="20" fill="#6c757d" opacity="0.3" />
          <path d="M 60 140 L 100 100 L 140 140" stroke="#6c757d" strokeWidth="2" fill="none" opacity="0.3" />
          <text x="50%" y="170" textAnchor="middle" dominantBaseline="middle" fill="#6c757d" fontSize="12">
            Imagen no disponible
          </text>
        </svg>
      </div>
    );
  }

  const imageUrl = candidates[attempt];

  return (
    <div className={`noticia-image-wrapper ${className}`}>
      {imageLoading && (
        <div className="noticia-image-loading">
          <div className="spinner"></div>
        </div>
      )}
      <img
        src={imageUrl}
        alt={alt || 'Imagen de noticia'}
        className="noticia-image"
        onLoad={() => setImageLoading(false)}
        onError={() => {
          setImageLoading(false);
          setAttempt((a) => a + 1);
        }}
        style={{ display: imageLoading ? 'none' : 'block' }}
      />
    </div>
  );
};

export default NoticiaImage;
